module.exports = __webpack_public_path__ + "img/shoulder width.bd393714.png";